// Card Quantity Controls JavaScript

class CardQuantityControls {
  constructor() {
    this.controls = document.querySelectorAll('.card-quantity-controls');
    this.init();
  }

  init() {
    this.controls.forEach(control => {
      this.setupControl(control);
    });
  }

  setupControl(control) {
    // Find the quick-add-bulk component
    const quickAddBulk = control.querySelector('quick-add-bulk');
    if (!quickAddBulk) return;
    
    const minusBtn = quickAddBulk.querySelector('[data-target^="decrement-"]');
    const plusBtn = quickAddBulk.querySelector('[data-target^="increment-"]');
    const quantityInput = quickAddBulk.querySelector('.quantity__input');
    const feedback = control.querySelector('.quantity-feedback');
    const feedbackText = control.querySelector('.feedback-text');
    
    if (minusBtn && plusBtn && quantityInput) {
      // Set initial state
      minusBtn.disabled = true;
      
      minusBtn.addEventListener('click', () => {
        const currentQty = parseInt(quantityInput.value) || 0;
        if (currentQty > 0) {
          const newQty = currentQty - 1;
          this.updateQuantity(quantityInput, minusBtn, newQty);
          this.updateCart('decrease', control, newQty);
        }
      });
      
      plusBtn.addEventListener('click', () => {
        const currentQty = parseInt(quantityInput.value) || 0;
        const newQty = currentQty + 1;
        this.updateQuantity(quantityInput, minusBtn, newQty);
        this.updateCart('increase', control, newQty);
      });
    }
  }

  updateQuantity(input, minusBtn, quantity) {
    if (input) input.value = quantity;
    if (minusBtn) minusBtn.disabled = quantity === 0;
    
    // Add visual feedback
    if (quantity > 0) {
      input.classList.add('has-items');
    } else {
      input.classList.remove('has-items');
    }
  }

  async updateCart(action, control, quantity = 1) {
    const productId = control.dataset.productId;
    const variantId = control.dataset.variantId;
    
    try {
      // Add to cart via AJAX
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });

      if (!response.ok) {
        throw new Error('Falha ao adicionar ao carrinho');
      }

      const data = await response.json();
      this.showFeedback(control, 'Item adicionado ao carrinho!', 'success');
      this.updateCartCount();
      this.updateCartDrawer();
      
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.showFeedback(control, 'Erro ao adicionar ao carrinho', 'error');
    }
  }

  showFeedback(control, message, type) {
    const feedback = control.querySelector('.quantity-feedback');
    const feedbackText = control.querySelector('.feedback-text');
    
    feedbackText.textContent = message;
    feedbackText.className = `feedback-text ${type}`;
    feedback.style.display = 'block';
    
    // Auto-hide after 2 seconds
    setTimeout(() => {
      feedback.style.display = 'none';
    }, 2000);
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Update cart count in header
      const cartCountElements = document.querySelectorAll('.cart-count-bubble, .cart-count, [data-cart-count]');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
      });
      
      // Update cart total if displayed
      const cartTotalElements = document.querySelectorAll('.cart-total, [data-cart-total]');
      cartTotalElements.forEach(element => {
        element.textContent = this.formatMoney(cart.total_price);
      });
      
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  async updateCartDrawer() {
    try {
      // Trigger cart drawer update if it exists
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents();
      }
      
      // Alternative: dispatch custom event
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
    } catch (error) {
      console.error('Error updating cart drawer:', error);
    }
  }

  formatMoney(cents) {
    // Simple money formatting - you can enhance this
    return `$${(cents / 100).toFixed(2)}`;
  }

  // Method to refresh controls (useful for dynamic content)
  refresh() {
    this.controls = document.querySelectorAll('.card-quantity-controls');
    this.init();
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.cardQuantityControls = new CardQuantityControls();
});

// Export for use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = CardQuantityControls;
}
